import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=1d0cbc6e&scoped=true&"
import script from "./kaoshi.vue?vue&type=script&lang=js&"
export * from "./kaoshi.vue?vue&type=script&lang=js&"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=1d0cbc6e&prod&lang=scss&scoped=true&"
import style1 from "./kaoshi.vue?vue&type=style&index=1&id=1d0cbc6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0cbc6e",
  null
  
)

export default component.exports